{
    "title":"Change Password",
    "changePassword": {
        "oldPassword": "Old Password",
        "newPassword": "New Password",
        "confirmPassword": "Confirm New Password"
    },

    "validatingMsgs":{
        "oldPswd":"Password is required",
        "newPswd":"Password is required",
        "mustValid":"Password must be at least 6 characters",
        "confirmNewPswd":"Confirm Password is required",
        "mustMatch":"Password Must be match"
    },
    "placeHolders":{
        "oldPswd": "Enter Your Old Password",
        "newPswd": "Enter New Password",
        "confirmNewPswd": "Confirm Password"
    },
    "resetBtn":{
        "label": "Reset"
    },
    "submitBtn":{
        "label":"Submit"
    }

    
}